import * as React from "react";
import EdButton from "../../generic/edButton";
import DeviceContext from "../../service/indentifyDevice";
import coverImage from "../../../assets/images/leadPages/genericInsuranceCover.png";
import firstImage from "../../../assets/images/leadPages/genericInsurance2.png";
import image2a from "../../../assets/images/leadPages/Bajaj1.jpg";
import image2b from "../../../assets/images/leadPages/Bajaj2.jpg";
import image2c from "../../../assets/images/leadPages/Bajaj3.jpg";
import image2d from "../../../assets/images/leadPages/Bajaj4.jpg";
import image2e from "../../../assets/images/leadPages/Bajaj5.jpg";
// import SecondImage from "../../../assets/images/leadPages/HDFCinsurance.png";
// import image3a from "../../../assets/images/leadPages/ETLI1.jpg";
// import image3b from "../../../assets/images/leadPages/ETLI2.jpg";
// import image3c from "../../../assets/images/leadPages/ETLI3.jpg";
// import image3d from "../../../assets/images/leadPages/ETLI4.jpg";
import GenericInsuranceIcons from "./../../../assets/icons/svgIcons/genericInsuranceIcons";
import { benefits, cards, insuranceDef, partners, types } from "./genericInsuranceConst";
import LeadForm, { TSubmitState } from "../leadForm/leadForm";
import LeadModal from "../leadForm/leadModal";
import gtmService from "../../service/gtmService";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export interface GenericInsuranceScreenProps {}

const GenericInsuranceScreen: React.FC<GenericInsuranceScreenProps> = () => {
	const [styles, setStyles] = React.useState({} as any);
	const [showTopBanner, setShowTopBanner] = React.useState(false);
	// since while showing/removing modal, we have to remove/show scroll in body
	// that's why this _setShowModal is not to be used.
	// use the setShowModal function defined below
	const [showModal, _setShowModal] = React.useState(false);
	const [modalPos, setModalPos] = React.useState<"Request_a_call_Banner" | "Request_a_call_Floating_Banner">("Request_a_call_Banner");
	const [formSubmitState, setFormSubmitState] = React.useState<TSubmitState | undefined>();
	const divRef = React.useRef(null);

	React.useEffect(() => {
		if (DeviceContext().isDesktop) {
			import("../../../assets/scss/components/leadPages/genericInsurance/genericInsuranceDsk.module.scss").then((style) => {
				setStyles(style.default);
			});
		} else {
			import("../../../assets/scss/components/leadPages/genericInsurance/genericInsuranceMob.module.scss").then((style) => {
				setStyles(style.default);
			});
		}
	}, []);

	function handleScroll() {
		if (((divRef.current as unknown) as HTMLDivElement).getBoundingClientRect().bottom < 52) {
			if (!showTopBanner) setShowTopBanner(true);
		} else {
			setShowTopBanner(false);
		}
	}

	// handle scroll event to show the top bar
	React.useEffect(() => {
		window.addEventListener("scroll", handleScroll);

		// unsubscribe the scroll event before unmount
		return function unsubscribe() {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	function changeSubmitState(state: TSubmitState) {
		setFormSubmitState(state);

		if (state !== "submitted") {
			setShowModal(true);
		}

		if (state === "success") {
			setTimeout(() => {
				setShowModal(false);
				setFormSubmitState(undefined);
			}, 3000);
		}
	}

	function setShowModal(show: boolean) {
		const bodyClassList = document.getElementsByTagName("body")[0].classList;
		if (show) {
			bodyClassList.add("no_scroll");
		} else {
			bodyClassList.remove("no_scroll");
		}
		_setShowModal(show);
	}

	function requestACall(position: "banner" | "floating") {
		const modalPosition: { [x: string]: "Request_a_call_Banner" | "Request_a_call_Floating_Banner" } = {
			banner: "Request_a_call_Banner",
			floating: "Request_a_call_Floating_Banner"
		};
		const action = { banner: "Request a call", floating: "Request_a_call_Top_banner" };

		setShowModal(true);
		setModalPos(modalPosition[position]);
		gtmService({ event: "event footer", category: "All Insurance", action: action[position], label: "click" });
	}

	return Object.keys(styles).length ? (
		<div className={styles.cont}>
			{/* Cover */}
			<div className={styles.gray}>
				<div className={`${styles.cover} ${DeviceContext().isDesktop ? styles.cont_width : ""}`}>
					<div className={`${styles.left} ${DeviceContext().isDesktop ? "" : styles.cont_width}`} ref={divRef}>
						<h2 className={styles.blue_head}>Insurance</h2>
						<h1>Financial protection amid contingencies</h1>
						<p className={styles.para}>
							Give your family financial security when you are no longer around or get a financial cushion against loss of any asset by
							buying an Insurance
						</p>
						<EdButton btnTyp="primary" value="Request a Call" className={styles.callback} onClick={() => requestACall("banner")} />
					</div>
					<div className={styles.right}>
						<img src={coverImage} alt="Insurance" />
					</div>

					{/* Show this after Request a callback button is scrolled-up out of view */}
					{showTopBanner && (
						<div className={styles.interested}>
							<span>Wish to know about our Insurance products?</span>
							<EdButton
								btnTyp={DeviceContext().isDesktop ? "blue-link" : "primary"}
								value="Request a Call"
								className={styles.callback_fix}
								onClick={() => requestACall("floating")}
							/>
						</div>
					)}
				</div>
			</div>

			{/* Insurance definition */}
			<div className={styles.white}>
				<div className={`${styles.desc} ${styles.cont_width}`}>
					<div className={`${styles.left} ib`}>
						<p className={`${styles.def} ${styles.heading}`}>
							Insurance is a contract between you and the insurance company whereby it provides you with financial protection amid
							contingencies in return of an amount paid, known as premium.
						</p>
						<p className={`${styles.types_head} ${styles.para}`}>Types of Insurance include:</p>
						<ul className={styles.types}>
							{types.map((type) => (
								<li key={type.title} className={`${styles.type} ib`}>
									<GenericInsuranceIcons
										icon={type.icon}
										style={DeviceContext().isDesktop ? { height: 44, width: 44 } : { height: 34, width: 34 }}
									/>
									<label className={styles.h3}>{type.title}</label>
								</li>
							))}
						</ul>
					</div>
					<div className={`${styles.right} ib`}>
						{insuranceDef.map((def) => (
							<div key={def.title} className={styles.data}>
								<h3 className={`${styles.r_h3} ${styles.h3}`}>{def.title}</h3>
								<p className={styles.r_p}>{def.body}</p>
							</div>
						))}
					</div>
				</div>
			</div>
			<OwlCarousel items={1} loop={true} autoplay ={true} >
			<div className={styles.gray}>
				<div className={`${styles.cont_width}`}>
					<img src={firstImage} className={`${styles.first_image}`} alt="Benefits" />
				</div>
			</div>
			<div>
				<a href="https://www.bajajallianzlife.com?utm_source=NUVAMA&utm_medium=INSURANCE&utm_campaign=BRANDCAMPAIGN" target="_blank" className={`${styles.cont_width}`}>
					<img className={`${styles.sec_image}`} src={image2a}/>
				</a>
			</div> 
			<div>
				<a href="https://www.bajajallianzlife.com?utm_source=NUVAMA&utm_medium=INSURANCE&utm_campaign=BRANDCAMPAIGN" target="_blank" className={`${styles.cont_width}`}>
					<img className={`${styles.sec_image}`} src={image2b}/>
				</a>
			</div> 
			<div>
				<a href="https://www.bajajallianzlife.com?utm_source=NUVAMA&utm_medium=INSURANCE&utm_campaign=BRANDCAMPAIGN" target="_blank" className={`${styles.cont_width}`}>
					<img className={`${styles.sec_image}`} src={image2c}/>
				</a>
			</div> 
			<div>
				<a href="https://www.bajajallianzlife.com?utm_source=NUVAMA&utm_medium=INSURANCE&utm_campaign=BRANDCAMPAIGN" target="_blank" className={`${styles.cont_width}`}>
					<img className={`${styles.sec_image}`} src={image2d}/>
				</a>
			</div> 
			<div>
				<a href="https://www.bajajallianzlife.com?utm_source=NUVAMA&utm_medium=INSURANCE&utm_campaign=BRANDCAMPAIGN" target="_blank" className={`${styles.cont_width}`}>
					<img className={`${styles.sec_image}`} src={image2e}/>
				</a>
			</div> 
			{/* <div>
				<a href="https://www.edelweiss.in/cas/trigger_mailer/HDFC-Life-LP2.html">
					<img className={`${styles.third_img}`} src= {SecondImage}/>
				</a>
			</div>
			<div className={`${styles.cont_width}`}>
				<img src={image3a} alt="Edelweiss_Tokyo_Life" />
			</div>
			<div className={`${styles.cont_width}`}>
				<img src={image3b} alt="Edelweiss_Tokyo_Life" />
			</div>
			<div className={`${styles.cont_width}`}>
				<img src={image3c} alt="Edelweiss_Tokyo_Life" />
			</div>
			<div className={`${styles.cont_width}`}>
				<img src={image3d} alt="Edelweiss_Tokyo_Life" />
			</div> */}
			</OwlCarousel>

			{/* Benefits */}
			<div className={styles.white}>
				<div className={`${styles.benefits} ${styles.cont_width}`}>
					<div className={`${styles.left} ib`}>
						<h2 className={styles.heading}>
							{DeviceContext().isDesktop
								? "There are several benefits of buying insurance, some them being:"
								: "Benefits of buying insurance"}
						</h2>
						<ul className={styles.types}>
							{benefits.map((benefit) => (
								<li className={`${styles.benefit} ib`} key={benefit.title}>
									<div className={styles.circle}>
										<GenericInsuranceIcons
											icon={benefit.icon}
											style={DeviceContext().isDesktop ? { height: 60, width: 60 } : { height: 44, width: 44 }}
										/>
									</div>
									<h3 className={styles.h3}>{benefit.title}</h3>
									<p className={styles.para}>{benefit.body}</p>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>

			{/* keep in mind */}
			<div className={styles.gray}>
				<div className={`${styles.kim} ${styles.cont_width}`}>
					<h2>Things to keep in mind</h2>
					<ul className={styles.cards}>
						{cards.map((card) => (
							<li className={`${styles.card} ib`} key={card.title}>
								<GenericInsuranceIcons icon={card.icon} />
								<h3>{card.title}</h3>
								<p className={styles.para}>{card.body}</p>
							</li>
						))}
					</ul>
				</div>
			</div>

			{/* Partners */}
			<div className={styles.white}>
				<div className={`${styles.ptnrs} ${styles.cont_width}`}>
					<h2 className={styles.heading}>Our Partners</h2>
					<ul className={styles.partners}>
						{partners.map((partner, i) => (
							<li className={`${styles.partner} ib ${i === partners.length - 1 ? styles.last : ""}`} key={partner.title}>
								<div className={i ===2 ? `${styles.image_container}` : ""}>
									<img src={partner.img} alt={partner.title} className={i ===2 ? `${styles.partner_image}` : ""}/>
								</div>
								<h3
									dangerouslySetInnerHTML={{
										__html: partner.title
									}}
								/>
								<p className={styles.tag}>
									<span>{partner.tag}</span>
								</p>
							</li>
						))}
					</ul>
				</div>
			</div>

			{/* Lead */}
			{DeviceContext().isDesktop && (
				<div className={styles.blue}>
					<div className={`${styles.lead_cont} ${styles.cont_width}`}>
						<div className={`${styles.left} ib`}>
							<h2>Want to know more about Insurance?</h2>
							<h3>Lets us give you a call</h3>
						</div>
						<div className={`${styles.right} ib`}>
							<LeadForm color="white" submitStateChange={changeSubmitState} gtmAction="Request_a_call_Bottom_Banner" />
						</div>
					</div>
				</div>
			)}

			{showModal && (
				<LeadModal onClose={() => setShowModal(false)} state={formSubmitState} retry={() => setFormSubmitState("initiated")}>
					<div className={styles.form_cont}>
						<LeadForm className={styles.spacing_30} submitStateChange={changeSubmitState} prefill gtmAction={modalPos} />
					</div>
				</LeadModal>
			)}
		</div>
	) : (
		<></>
	);
};

export default GenericInsuranceScreen;
